import color from 'color';

const themeColors: {
  primaryColor: color;
  primaryColorHover: color;
  textSecondary: color;
  textPrimaryColor: color;
  secondaryColor: color;
  secondaryColorHover: color;
  textSecondaryColor: color;
  warningColor: color;
  dangerColor: color;
  successColor: color;
  infoColor: color;
  roseColor: color;
  grayColor: color;
  white: color;
  black: color;
  midnight: color;
  background: color;
  divider: color;
  focusOutlineColor: color;
  disabledColor: color;
  disabledContrastColor: color;
  warningBackgroundColor: color;
  warningTextColor: color;
  cornerColors: {
    activity: color;
    activityContrast: color;
    reward: color;
    rewardContrast: color;
    promotion: color;
    promotionContrast: color;
    game: color;
    gameContrast: color;
  };
  accessibilityWarningColor: color;
} = {
  primaryColor: color('#1B3E6F'),
  primaryColorHover: color('#00a8e1'),
  textSecondary: color('#51748b'),
  textPrimaryColor: color('#51748b'),
  secondaryColor: color('#0099cc'),
  secondaryColorHover: color('#ffffff'),
  textSecondaryColor: color('#51748B'),
  warningColor: color('#ffd200'),
  dangerColor: color('#D22E0C'),
  successColor: color('#6Fa338'),
  infoColor: color('#00acc1'),
  roseColor: color('#e91e63'),
  grayColor: color('#999999'),
  white: color('#ffffff'),
  black: color('#000000'),
  midnight: color('#1B3E6F'),
  background: color('#F1F7F8'),
  divider: color('#CDE8EA'),
  focusOutlineColor: color('#2D3142'),
  disabledColor: color('#B0BEC6'),
  disabledContrastColor: color('#FFFFFF'),
  warningBackgroundColor: color('#ffd7e3'),
  warningTextColor: color('#0d1b23'),
  cornerColors: {
    activity: color('#1B3E6F'),
    activityContrast: color('#FFFFFF'),
    reward: color('#0099cc'),
    rewardContrast: color('#000000'),
    promotion: color('#ffffff'),
    promotionContrast: color('#1B3E6F'),
    game: color('#6Fa338'),
    gameContrast: color('#ffffff')
  },
  accessibilityWarningColor: color('#d82a00')
};

export default themeColors;
